<div class="row justify-content-center" id="frmStatusReqNewDoc">
  <div class="col-9 mt-5 mb-5 container">
    <div class="row mt-3">
      <div class="col-md-12 text-center">
        <h4 class="text-cust-blue" translate>เอกสารที่ต้องการ</h4>
      </div>
    </div>


    <!-- table -->
    <div class="card-body table">
      <table style="width:100%" class="table table-bordered table-hover result-table">
        <thead>
          <tr class="tbheader">
            <!--  <th class="checkbox-col">
              <input type="checkbox" id="chkboxAll">
            </th> -->
            <th>วันที่ทำรายการ</th>
            <th>เลขที่คำขอ</th>
            <th>สถานะคำขอ</th>
            <th></th>
          </tr>
        </thead>
        <tbody id="tbcrm08DROS">
          <tr *ngFor="let c of crm08DROSList; let i = index">
            <!-- <td class="checkbox-col">
              <input type="checkbox" class="row-checker" value="{{c.RequestedNo}}" name="chkReqNo"
                (change)="onCheckChange()">
            </td>-->
            <td>{{c.CreateOn}}</td>
            <td>{{c.DROSRequestNo}}</td>
            <td>{{c.ProcessStatus}}</td>
            <td> <button class="btn btn-default btn-detail" (click)="ShowDetail(c.DROSRequestNo)" translate>รายละเอียด</button></td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="row mt-5 mb-5">
      <div class="col-12 text-center">
        <button class="btn btn-default mr-2" (click)="BackToReDoc()" translate>Back</button>
      </div>
    </div>
  </div>
</div>

<div class="row mt-3 mb-3 hideDiv" id="divDetail">
  <div class="col-12">
    <div class="row">
      <div class="col-12 text-center">
        <h4 class="text-cust-blue" translate>บุคคลธรรมดา/นิติบุคคล/ต่างชาติ/อื่นๆ</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 mx-auto container container2">
       <!-- <div class="row rowmargin">
          <div class="text-cust-blue col" translate>Name</div>
          <div class="col-md-4 divlbl">
            <label id="lblName">ทวีศักดิ์</label>
          </div>
          <div class="col-md-1 text-cust-blue" translate>Surname</div>
          <div class="col-md-6 divlbl">
            <label id="lblSurname">อุปะละ</label>
          </div>
        </div>-->
        <div class="row rowmargin">
          <div class="text-cust-blue col" translate>ชื่อ-นามสกุล</div>
          <div class="col-md-10 divlbl">
            <label id="lblFullname">555 666</label>
          </div>
        </div>
        <div class="row rowmargin">
          <div class="text-cust-blue col" translate>หมายเลขโทรศัพท์</div>
          <div class="col-md-10 divlbl">
            <label id="lblPhoneNo">0888888888</label>
          </div>
        </div>
        <div class="row rowmargin">
          <div class="text-cust-blue col" translate>ที่อยู่จัดส่ง</div>
          <div class="col-md-10 divlbl">
            <!--  <input type="text" class="form-control form-control-2" id="txtIDNo">  -->
            <label id="lblAddress">300 กดเกดเ กดเกดเกด</label>
          </div>
        </div>

        <div class="row rowmargin">
          <div class="text-cust-blue col" translate>หมายเลขคำร้อง</div>
          <div class="col-md-10 divlbl">
            <!-- <input type="text" class="form-control form-control-2" maxlength="13" id="txtAccNo"> -->
            <label id="lblDROSReqNo">123456789014441</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Progress -->
    <div id="divProgress">
      <div class="row mt-4 text-center">
        <div class="col-md-12">
          <ul id="progressbarimg" class="progressbar-img content-center"> 
                  <li class="active step0"><img id="imgStatus01"  src="../../assets/images/reqDocStatus01.png"></li> 
                  <li class="active step0"><img id="imgStatus02"  src="../../assets/images/reqDocStatus02.png"></li> 
                  <li class="active step0"><img id="imgStatus03"  src="../../assets/images/reqDocStatus03.png"></li> 
          </ul>
        </div>
    </div>
    <!-- End Progress -->

    <div class="row mt-5 mb-5">
      <div class="col-12 text-center">
        <button class="btn btn-default mr-2" (click)="BackToList()" translate>Back</button>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/status-request-document/status-request-document.component.html